import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioOverview = ({ portfolioData, selectedCurrency }) => {
  const formatCurrency = (amount, currency = selectedCurrency) => {
    const symbols = { USD: '$', EUR: '€', BTC: '₿', ETH: 'Ξ' };
    const decimals = currency === 'BTC' || currency === 'ETH' ? 6 : 2;
    return `${symbols?.[currency]}${amount?.toLocaleString('en-US', { 
      minimumFractionDigits: decimals, 
      maximumFractionDigits: decimals 
    })}`;
  };

  const getChangeColor = (change) => {
    if (change > 0) return 'text-success';
    if (change < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (change) => {
    if (change > 0) return 'TrendingUp';
    if (change < 0) return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {/* Total Portfolio Value */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Total Portfolio Value</h3>
          <Icon name="Wallet" size={20} className="text-primary" />
        </div>
        <div className="space-y-1">
          <p className="text-3xl font-bold text-foreground">
            {formatCurrency(portfolioData?.totalValue)}
          </p>
          <div className={`flex items-center space-x-1 ${getChangeColor(portfolioData?.change24h)}`}>
            <Icon name={getChangeIcon(portfolioData?.change24h)} size={16} />
            <span className="text-sm font-medium">
              {formatCurrency(Math.abs(portfolioData?.change24h))} ({Math.abs(portfolioData?.changePercent24h)?.toFixed(2)}%)
            </span>
          </div>
        </div>
      </div>
      {/* Best Performer */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Best Performer (24h)</h3>
          <Icon name="Trophy" size={20} className="text-success" />
        </div>
        <div className="space-y-1">
          <p className="text-xl font-bold text-foreground">{portfolioData?.bestPerformer?.symbol}</p>
          <div className="flex items-center space-x-1 text-success">
            <Icon name="TrendingUp" size={16} />
            <span className="text-sm font-medium">
              +{portfolioData?.bestPerformer?.change?.toFixed(2)}%
            </span>
          </div>
        </div>
      </div>
      {/* Worst Performer */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-muted-foreground">Worst Performer (24h)</h3>
          <Icon name="TrendingDown" size={20} className="text-error" />
        </div>
        <div className="space-y-1">
          <p className="text-xl font-bold text-foreground">{portfolioData?.worstPerformer?.symbol}</p>
          <div className="flex items-center space-x-1 text-error">
            <Icon name="TrendingDown" size={16} />
            <span className="text-sm font-medium">
              {portfolioData?.worstPerformer?.change?.toFixed(2)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioOverview;